export class GetImageInfoRequestModel {
  public formId: string = <string>'';                       // 画面ＩＤ
  public pcode: string = <string>'';                        // Pコード
  public guideGoodsName: string = <string>'';			          // 商品案内用商品名
  public guideStandardName: string = <string>'';		        // 商品案内用規格名
  public imageName: string = <string>'';                    // 画像名
  public imageFileName: string = <string>'';                // 画像ファイル名
  public imageBelongId: string = <string>'';                // 所属
  public imageKind: string = <string>'';                    // 画像種類
  public imageType: string = <string>'';                    // 画像種別
  public processInstruct: string = <string>'';              // 加工指示
  public remarks: string = <string>'';                      // 備考
  public cookingExPublish: string = <string>'';             // 調理例掲載区分
  public cookingDiv: string = <string>'';                   // 料理分類
  public cookingName: string = <string>'';                  // 料理名
  public materialName: string = <string>'';                 // 材料名
  public keyWord: string = <string>'';                      // キーワード
  public eventId: string = <string>'';                      // 催事・季節
  public photoContentsDiv: string = <string>'';             // 撮影内容区分
  public photoStudioId: string = <string>'';                // 撮影場所
  public imageInstructUserId: string = <string>'';          // 作成指示者
  public imageInstructDateFrom: string = <string>'';        // 作成指示日（ＦＲＯＭ）
  public imageInstructDateTo: string = <string>'';          // 作成指示日（ＴＯ）
  public fileRegistDateFrom: string = <string>'';           // 画像ファイル登録日（ＦＲＯＭ）
  public fileRegistDateTo: string = <string>'';             // 画像ファイル登録日（ＴＯ）
  public status: string = <string>'';                       // ステータス
  public imageInstruct: string = <string>'';                // 画像作成指示
  public enabled: string = <string>'';                      // 使用停止フラグ
  public sortItem: string = <string>'';                     // ソート指定項目
  public sortOrder: string = <string>'';                    // 昇順降順
  public page = 0;                                          // 取得対象ページ
  public photoScheduleFrom: string = <string>'';            // 撮影予定日(From)
  public photoScheduleTo: string = <string>'';              // 撮影予定日(To)
  public studio: string = <string>'';                       // スタジオ
  public classCode: string = <string>'';                    // 部門コード
  public multipleCode: boolean = <boolean>false;            // 複数コード登録
  public startOrderCode: string = <string>'';               // 使用開始受注コード
  public startDelivCatalogId: string = <string>'';          // 使用開始配達企画回(翌週)
  public billingName: string = <string>'';                  // 請求先名
  public buyerCode: string = <string>'';                    // バイヤーコード
  public outputFlg: string = <string>'';                    // 出力／未出力選択
  public c2pfStatus: string = <string>'';                   // C2PFステータス
  public imageUseProcess: string = <string>'';              // 画像使用方法
  public carriedForward: boolean = <boolean>false;          // 繰越
  public c2pfTarget: boolean = <boolean>false;              // C2PF対象
  public photographingChangeSchedule: boolean = <boolean>false;  // 変更前撮影予定日
  public supplierAnnouncement: boolean = <boolean>false;         // 取引先コメント

  /**
   * コンストラクタ
   */
  public GetImageInfoRequestModel() { }
}